const ResidentSettingsNavigationQueryParameters = {
  ResidentOrganisationUnitId: 'residentOrganisationUnitId',
  ParentOrganisationUnitId: 'parentOrganisationUnitId',
  SearchTerm: 'searchTerm',
} as const;

export default ResidentSettingsNavigationQueryParameters;
